// extracted by mini-css-extract-plugin
module.exports = {"Box":"CustomFadeBox_Box__3TEaR","Div":"CustomFadeBox_Div__32TIX","LargeDiv":"CustomFadeBox_LargeDiv__3chme"};